import React from "react";
import { EMPLOYER_TOUR_SELECTORS } from "./tourConfig";
import { TourStepExtended } from "./tourSteps";

export const employerTourSteps: TourStepExtended[] = [
  // Welcome
  {
    target: "body",
    content: (
      <div>
        <h2 style={{ marginBottom: "12px", fontSize: "20px", fontWeight: "600" }}>
          Welcome to Administr!
        </h2>
        <p style={{ marginBottom: "10px" }}>
          Let's take a quick tour to help you set up your company and manage your team.
        </p>
        <p>
          We'll walk you through the main sections so you know where everything is.
        </p>
      </div>
    ),
    placement: "center",
    disableBeacon: true,
  },

  // Sidebar items
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarDashboard,
    title: "Dashboard",
    content: (
      <div>
        <p>
          Your HR dashboard shows employee metrics, benefits enrollment status,
          pending actions, and compliance scores at a glance.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarCompany,
    title: "Company Profile",
    content: (
      <div>
        <p>
          Complete your company information here — address, EIN, entity type,
          and primary contact details. This is the first thing to set up.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarEmployees,
    title: "Employees",
    content: (
      <div>
        <p>
          Add your employees individually or import them in bulk via CSV.
          Manage their profiles, employment details, and benefits from here.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarBenefits,
    title: "Benefits",
    content: (
      <div>
        <p>
          View your company's benefit plans and track employee enrollments.
          Manage open enrollment windows and monitor coverage status.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarTimeOff,
    title: "Time Off",
    content: (
      <div>
        <p>
          Manage PTO policies, review time-off requests from your employees,
          and track balances across your team.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarDocuments,
    title: "Documents",
    content: (
      <div>
        <p>
          Store and share company documents. Upload policies, handbooks,
          and compliance forms that your employees can access.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },
  {
    target: EMPLOYER_TOUR_SELECTORS.sidebarCompliance,
    title: "Compliance",
    content: (
      <div>
        <p>
          Track compliance requirements and deadlines. Monitor ACA status,
          COBRA obligations, and other regulatory items.
        </p>
      </div>
    ),
    placement: "right",
    disableBeacon: true,
  },

  // Closing
  {
    target: "body",
    content: (
      <div>
        <h2 style={{ marginBottom: "12px", fontSize: "20px", fontWeight: "600" }}>
          You're All Set!
        </h2>
        <p style={{ marginBottom: "10px" }}>
          You now know your way around the platform.
        </p>
        <p>
          Start by completing your <strong>Company Profile</strong>, then
          add your <strong>Employees</strong> — you can import them all at
          once via CSV.
        </p>
        <p style={{ marginTop: "15px", fontSize: "13px", color: "#666" }}>
          If you need help, reach out to your insurance broker.
        </p>
      </div>
    ),
    placement: "center",
    disableBeacon: true,
    requiresNavigation: {
      path: "/",
    },
  },
];
